import forIn from 'lodash/forIn'

const heights = {
  appHeader: 35,
  offer: 60,
  search: 85.5,
  filters: 24,
  appliedFilters: 28,
  footer: 36,
  mysocutFilters: 40,
  myscoutProjectsHeader: 85.5,
  myscoutFolderHeader: 94.5
}

export const state = () => ({
  windowHeight: window.innerHeight,
  show: {
    appHeader: true,
    offer: false,
    search: true,
    filters: true,
    appliedFilters: false,
    footer: true,
    myscoutProjectsHeader: false,
    myscoutFolderHeader: false,
    mysocutFilters: false
  }
})

export const getters = {
  height (state) {
    let reservedSpace = 0
    forIn(state.show, (value, key) => {
      if (value) {
        reservedSpace += heights[key]
      }
    })

    return state.windowHeight - reservedSpace
  }
}

export const mutations = {
  setWindowHeight (state, height) {
    state.windowHeight = height
  },
  set (state, values) {
    forIn(values, (value, key) => {
      state.show[key] = values[key]
    })
  },
  setShow (state, { key, value }) {
    state.show[key] = value
  }
}
